import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { AwsAccountAboutCard } from '../../components/catalog/AwsAccountAboutCard';
import { AwsAccountRolesCard } from '../../components/catalog/AwsAccountRolesCard';

const awsAccountAboutCard = EntityCardBlueprint.make({
  name: 'aws-account-about',
  params: {
    filter: 'kind:resource,spec.type=aws-account',
    loader: async () => compatWrapper(<AwsAccountAboutCard />),
  },
});

const awsAccountRolesCard = EntityCardBlueprint.make({
  name: 'aws-account-roles',
  params: {
    filter: 'kind:resource,spec.type=aws-account',
    loader: async () => compatWrapper(<AwsAccountRolesCard />),
  },
});

export const awsAccountsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [awsAccountAboutCard, awsAccountRolesCard],
});
